"use client";

import { FC } from "react";
import { Search, XLg } from "react-bootstrap-icons";

import useStateData from "@/hooks/useStateData";

const ProjectSearch: FC = () => {
  const { searchFilter, handleSearchFilter } = useStateData();

  return (
    <label className="input dark:bg-secondary-dark focus:outline-none focus-within:outline-none md:mb-0 sm:mb-4 xs:mb-4">
      <Search />
      <input
        onChange={(e) => handleSearchFilter(e.target.value)}
        placeholder="Search Projects"
        type="search"
        value={searchFilter}
      />
      <span className="cursor-pointer" onClick={() => handleSearchFilter("")}>
        <XLg />
      </span>
    </label>
  );
};

export default ProjectSearch;
